import { AssetTypeIdentifierValueService as OvermapAssetTypeIdentifierValueService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class AssetTypeIdentifierValueService extends OvermapAssetTypeIdentifierValueService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
